export default __webpack_public_path__ + "static/media/24.a5a18029.png";